import {Col, Divider, Form, Input, Row, Spin} from "antd";
import React from "react";
import {ContainerForm} from "../Identification/styles";
import {TextDivider} from "../Vehicles/styles";

import {CalendarOutlined, CarOutlined, UserOutlined} from '@ant-design/icons';
import Vehicle from "../../models/Vehicle";
import ItemVacancy from "../../models/ItemVacancy";
import {maskChassi} from "../../utils/StringUtils";

interface FormScheduleData {
    contactName: string,
    contactDDD: number,
    contactNumber: string,
    pontoDeReferencia: string,
    obsReserveExternal: string,
    attendanceForm: string,
    period: string,
    clientAddress: string
}

interface FinishProps {
    proprietaryName: string,
    formScheduleData: FormScheduleData,
    emailInformed: string,
    vehicleData: Vehicle,
    vacancyData: ItemVacancy
    isLoad: boolean

}

const Finish: React.FC<FinishProps> = ({
                                           proprietaryName,
                                           formScheduleData,
                                           emailInformed,
                                           vehicleData,
                                           vacancyData,
                                           isLoad,
                                           ...rest
                                       }: FinishProps) => {
    return (
        <Spin spinning={isLoad}>
            <ContainerForm>
                <Form
                    layout="vertical"
                    name="wrap"
                    // labelCol={{ span: 4 }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{flex: 1}}
                    colon={false}
                >
                    <Divider orientation="center" plain><TextDivider><UserOutlined/> Dados pessoais
                    </TextDivider></Divider>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                        <Col xl={11} xs={24}>
                            <Form.Item label="Proprietário">
                                <Input value={proprietaryName} disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={8} xs={24} sm={16}>
                            <Form.Item label="Email">
                                <Input value={emailInformed} disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={5} xs={24} sm={8}>
                            <Form.Item label="Telefone">
                                <Input value={'(' + formScheduleData.contactDDD + ')' + formScheduleData.contactNumber}
                                       disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider orientation="center" plain><TextDivider><CarOutlined/> Dados do veículo
                    </TextDivider></Divider>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                        <Col xl={5} xs={15} sm={10}>
                            <Form.Item label="Chassis">
                                <Input value={maskChassi(vehicleData.vehicleChassi)}  disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={4} xs={9} sm={6}>
                            <Form.Item label="Placa">
                                <Input value={vehicleData.vehiclePlate} disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={6} xs={24} sm={8}>
                            <Form.Item label="Marca">
                                <Input value={vehicleData.vehicleManufacturerName} disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={9} xs={24} sm={24}>
                            <Form.Item label="Modelo">
                                <Input value={vehicleData.vehicleModelName} disabled/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Divider orientation="center" plain><TextDivider><CalendarOutlined/> Dados do agendamento
                    </TextDivider></Divider>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                        <Col xl={8} xs={24} sm={6}>
                            <Form.Item label="Forma Atendimento">
                                <Input value={formScheduleData.attendanceForm} disabled/>
                            </Form.Item>
                        </Col>
                        <Col xl={16} xs={24} sm={18}>
                            <Form.Item label="Endereço">
                                <Input
                                    value={ formScheduleData.attendanceForm === "1 - Ponto Fixo" ? vacancyData.warehouseDto.fcWarehouseNm + ' ' + vacancyData.warehouseDto.fcWarehouseAddNu + ', ' +
                                        vacancyData.warehouseDto.fcWarehousePostCodeNu + ' - ' + vacancyData.warehouseDto.cityDto.fcCityNm + '/' + vacancyData.warehouseDto.cityDto.stateDto.fcStateNM : formScheduleData.clientAddress}
                                    disabled/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
                        <Col xl={8} xs={24} sm={10} className="gutter-row">
                            <Form.Item label="Data">
                                <Input value={vacancyData.vacancyTimeDto.fdVacTimeIniDt.split(' ')[0]} disabled/>
                            </Form.Item>
                        </Col>
                        {(formScheduleData.attendanceForm === "1 - Ponto Fixo") && (
                            <>
                                <Col xl={8} xs={12} sm={7} className="gutter-row">
                                    <Form.Item label="Hora Início">
                                        <Input value={vacancyData.vacancyTimeDto.fdVacTimeIniDt.split(' ')[1]}
                                               disabled/>
                                    </Form.Item>
                                </Col>
                                <Col xl={8} xs={12} sm={7} className="gutter-row">
                                    <Form.Item label="Hora Fim">
                                        <Input value={vacancyData.vacancyTimeDto.fdVacTimeEndDt.split(' ')[1]}
                                               disabled/>
                                    </Form.Item>
                                </Col>
                            </>
                        )}

                        {(formScheduleData.attendanceForm === "2 - Domicílio") && (
                            <>
                            <Col xl={8} xs={12} sm={7} className="gutter-row">
                                <Form.Item label="Período">
                                    <Input value={formScheduleData.period} disabled/>
                                </Form.Item>
                            </Col>
                            </>
                        )}
                    </Row>
                </Form>

            </ContainerForm>
        </Spin>
    )
}

export default Finish;